module.exports = __webpack_public_path__ + "img/CHE.991c1314.gif";